import { Outlet, Navigate } from 'react-router-dom';
import Header from './Header.jsx';
import Sidebar from './Sidebar.jsx';
import Footer from './Footer.jsx';
import { useLocalStorage } from '../../hooks/useLocalStorage.js';
import { STORAGE_KEYS, ROUTES } from '../../utils/constants.js';
import { useSystemAdminRegisterAvailable } from '../../hooks/queries/authQueries.js';
import './AppLayout.css';

/**
 * 토큰이 유효한지 확인하는 함수
 */
const isTokenValid = (token) => {
  if (!token) return false;
  
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const currentTime = Date.now() / 1000;
    return payload.exp > currentTime;
  } catch (error) {
    return false;
  }
};

const AppLayout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useLocalStorage(
    STORAGE_KEYS.SIDEBAR_COLLAPSED,
    false
  );

  // 토큰 확인
  const accessToken = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN) || localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN);
  const hasValidToken = accessToken && isTokenValid(accessToken);
  
  // 토큰이 없을 때만 시스템 관리자 존재 여부 확인
  const { data: systemAdminStatus, isLoading: isCheckingSystemAdmin } = useSystemAdminRegisterAvailable(!hasValidToken);
  
  // 토큰이 없으면 시스템 관리자 존재 여부에 따라 리다이렉트 (렌더링 전에 처리)
  if (!hasValidToken) {
    // 시스템 관리자 존재 여부 확인 중이면 대기
    if (isCheckingSystemAdmin) {
      return null;
    }
    
    // 시스템 관리자가 없으면 시스템 로그인 페이지로 이동
    if (systemAdminStatus?.status === true) {
      return <Navigate to={ROUTES.SYSTEM_LOGIN} replace />;
    }
    
    // 시스템 관리자가 있으면 일반 로그인 페이지로 이동
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <div className={`app-layout flex ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
      <Sidebar collapsed={sidebarCollapsed} onToggleSidebar={toggleSidebar}/>
      <div className="app-content flex flex-col">
        <Header />
        
        <main className="main-content flex flex-col flex-1">
          <div className="content-wrapper flex flex-col flex-1">
            <Outlet />
          </div>
        </main>
        <Footer />
      </div>
      
    </div>
  );
};

export default AppLayout; 